export default "__VITE_ASSET__BDR4KxnS__"